<template>
    <div class="cell-render-with-label">
        {{ params.value.value }} <span style="font-size: 12px; color:#95979a;font-weight: 400">{{ params.value.label }}</span>
    </div>
</template>

<script>
export default {}
</script>
